module.exports = __webpack_public_path__ + "static/media/Gurantee.013313d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/Gurantee.png
// module id = 779
// module chunks = 5